module.exports = __webpack_public_path__ + "static/img/case-solution-diagram-02.64ca3bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-solution-diagram-02.png
// module id = FbWH
// module chunks = 1